export const subGroupPlugin = {
    id: 'subgroupLabels',
    afterDraw: (chart) => {
        const ctx = chart.ctx;
        const xAxis = chart.scales['month-axis'];
        const yAxis = chart.scales['y-axis-left'];

        if (!xAxis || !yAxis) return;

        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = '12px Arial';
        ctx.fillStyle = '#666';

        // Perhitungan untuk masing-masing grup bulan
        const totalDatasets = chart.data.datasets.length;
        // const stacksPerGroup = 3; // I, II, III
        // const stacksPerMonth = totalDatasets / stacksPerGroup;

        // Untuk setiap bulan (label)
        chart.data.labels.forEach((label, monthIndex) => {
            // Dapatkan seluruh bar untuk bulan ini
            const barGroups = {
                I: [],
                II: [],
                III: []
            };

            // Ambil semua meta untuk dataset yang terkait dengan bulan ini
            for (let dsIndex = 0; dsIndex < totalDatasets; dsIndex++) {
                const meta = chart.getDatasetMeta(dsIndex);
                if (!meta.hidden && meta.data[monthIndex]) {
                    const stack = chart.data.datasets[dsIndex].stack;
                    if (stack === 'I') barGroups.I.push(meta.data[monthIndex]);
                    if (stack === 'II') barGroups.II.push(meta.data[monthIndex]);
                    if (stack === 'III') barGroups.III.push(meta.data[monthIndex]);
                }
            }

            // Hitung posisi x tengah untuk setiap grup
            const getCenterX = (bars) => {
                if (bars.length === 0) return null;
                return bars.reduce((sum, bar) => sum + bar._model.x, 0) / bars.length;
            };

            const xI = getCenterX(barGroups.I);
            const xII = getCenterX(barGroups.II);
            const xIII = getCenterX(barGroups.III);

            // Gambar label subgroup jika posisi tersedia
            if (xI) ctx.fillText('I', xI, yAxis.bottom + 15);
            if (xII) ctx.fillText('II', xII, yAxis.bottom + 15);
            if (xIII) ctx.fillText('III', xIII, yAxis.bottom + 15);
        });
        ctx.restore();
    }
}

export const yearLabelPlugin = {
    id: 'yearLabel',
    afterDraw: function (chart) {
        const ctx = chart.ctx;
        const xAxis = chart.scales['month-axis'];
        const yAxis = chart.scales['y-axis-left'];
        if (!xAxis) return;
        ctx.font = '12px Arial';
        ctx.fillStyle = '#666';
        ctx.textAlign = 'center';
        const labels = chart.data.labels;
        let currentYear = null;
        let startIndex = 0;
        labels.forEach((label, index) => {
            const year = label.split('-')[0];
            if (currentYear !== year) {
                if (currentYear !== null) {
                    const startX = xAxis.getPixelForTick(startIndex);
                    const endX = xAxis.getPixelForTick(index - 1);
                    const width = endX - startX;
                    const centerX = startX + width / 2;
                    ctx.fillText(currentYear, centerX, yAxis.bottom + 50);
                }

                currentYear = year;
                startIndex = index;
            }

            if (index === labels.length - 1) {
                const startX = xAxis.getPixelForTick(startIndex);
                const endX = xAxis.getPixelForTick(index);
                const width = endX - startX;
                const centerX = startX + width / 2;

                ctx.fillText(currentYear, centerX, yAxis.bottom + 50);
            }
        });
    }
}

export const proportionalZeroAlignPlugin = {
    id: 'proportionalZeroAlign',
    beforeUpdate(chart) {
        const yAxes = chart.options.scales?.yAxes || [];
        if (yAxes.length < 2) return;

        let globalPosNorm = 0;
        let globalNegNorm = 0;
        const ranges = [];

        // Step 1: gather proportional ranges for each y-axis
        yAxes.forEach(axis => {
            const axisId = axis.id || 'y-axis-0';
            const datasets = chart.data.datasets.filter(
                ds => (ds.yAxisID || 'y-axis-0') === axisId
            );

            const values = datasets.flatMap(ds =>
                ds.data.map(v => typeof v === 'number' ? v : v.y)
            );

            if (!values.length) {
                ranges.push({absMax: 1, posNorm: 0, negNorm: 0});
                return;
            }

            const min = Math.min(...values);
            const max = Math.max(...values);
            const absMax = Math.max(Math.abs(max), Math.abs(min)) || 1;

            const posNorm = max / absMax;
            const negNorm = min / absMax;

            ranges.push({absMax, posNorm, negNorm});

            if (posNorm > globalPosNorm) globalPosNorm = posNorm;
            if (negNorm < globalNegNorm) globalNegNorm = negNorm;
        });

        if (globalPosNorm === 0 && globalNegNorm === 0) return;

        // Step 2: apply proportional min/max to all y-axes
        yAxes.forEach((axis, i) => {
            const {absMax} = ranges[i];
            axis.ticks.min = (globalNegNorm * 1.05) * absMax;
            axis.ticks.max = (globalPosNorm * 1.05) * absMax;
        });
    }
};

// Draw centered text when there is no data to display
export const emptyCenterTextPlugin = {
    id: 'emptyCenterText',
    afterDraw(chart) {
        const datasets = chart.data?.datasets || [];
        if (!datasets.length) return;

        const hasData = datasets.some(ds => {
            const arr = Array.isArray(ds.data) ? ds.data : [];
            return arr.some(v => v !== null && v !== undefined && Number(v) !== 0);
        });

        if (hasData) return;

        const ctx = chart.ctx;
        const area = chart.chartArea;
        if (!area) return;

        const getTextFn = chart.options && chart.options.emptyState && chart.options.emptyState.getText;
        const fallbackText = chart.options && chart.options.emptyState && chart.options.emptyState.text;
        const text = typeof getTextFn === 'function'
            ? getTextFn(chart)
            : (fallbackText || 'Tidak ada data\ndari filter yang diterapkan');

        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#6C7589';
        ctx.font = '500 14px Lato, Arial, sans-serif';
        const cx = (area.left + area.right) / 2;
        const cy = (area.top + area.bottom) / 2;
        const lines = String(text).split('\n');
        const lineHeight = 20; // px
        const startY = cy - ((lines.length - 1) * lineHeight) / 2;
        lines.forEach((ln, i) => {
            ctx.fillText(ln, cx, startY + i * lineHeight);
        });
        ctx.restore();
    }
};

export const paddingBelowLegends = {
    id: 'paddingBelowLegends',
    beforeInit: function(chart) {
        chart.legend.afterFit = function() {
            this.height = this.height + 75;
        };
    }
}